export const LOGIN = 'USE_AUTH_LOGIN';
export const LOGOUT = 'USE_AUTH_LOGOUT';
export const RETRIEVED_ALL_USER_INFO = 'RETRIEVED_ALL_USER_INFO';
export const USER_LIGHTBOX = 'USER_LIGHTBOX';
export const START_AUTHENTICATION = 'USE_AUTH_START_AUTHENTICATION';
export const STOP_AUTHENTICATION = 'USE_AUTH_STOP_AUTHENTICATION';
export const ERROR = 'USE_AUTH_ERROR';
